'use client';

import { useSyncExternalStore } from 'react';
import { getCoarsePointerQuery } from './coarsePointerQuery';
function subscribe(onChange: () => void) {
  const mediaQueryList = getCoarsePointerQuery();
  mediaQueryList?.addEventListener('change', onChange);
  return () => mediaQueryList?.removeEventListener('change', onChange);
}
function getSnapshot() {
  return getCoarsePointerQuery()?.matches ?? false;
}
function getServerSnapshot() {
  return false;
}

/**
 * Whether any input device is a coarse pointer (touchscreen), including hybrid devices such as
 * touchscreen laptops. Always `false` on the server and during hydration.
 */
export function useHasTouchInput() {
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}